import React ,{useEffect} from "react";
import { MetaTags } from "react-meta-tags";
//import Breadcrumbs
import {
    Breadcrumbs,
    DashBreadcrumb,
  } from "../../components/Common/Breadcrumb";

import ManageProductList from "./components/ManageProductList";
import OrderExportReport from "../Orders/components/OrderExportReport";



import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

const Photoshoot = () => {
  
  const title = "Orders";
  const description = "Manage Orders";
 // const countryAll = "All";

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Product Shoots</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="PhotoShoot" breadcrumbItem="Manage Product Shoots " />
            </Col>
            {/* <OrderExportReport />  */}
           
          </Row>
          
         <ManageProductList  /> 
         
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Photoshoot;
